import React from "react";
import { makeStyles } from "@material-ui/core";
import Appbar from "../../components/Appbar";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ListarFotos from "../../components/ListarFotos";

export default function VisualizarAlbum({
  match: {
    params: { idAlbum },
  },
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <Appbar />
      <div className={classes.content}>
        <div className={classes.limit}>
          <ListarFotos idAlbum={idAlbum} />
        </div>
      </div>
      <Footer />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: "column",
    display: "flex",
    minHeight: "100vh",
    width: "100vw",
    backgroundColor: theme.colors.white,
  },
  content: {
    marginTop: "48px",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    width: "100vw",
  },
  paginas: {},
  limit: {
    width: "100%",
    maxWidth: "1376px",
    paddingRight: "5px",
    paddingLeft: "21px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
}));
